import {
  Box,
  Button,
  Divider, makeStyles, Typography,
} from '@material-ui/core';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import ListIcon from '@material-ui/icons/List';
import PropTypes from 'prop-types';

import bot1 from '../../assets/img/bot-kami.png';
import questionBox from '../../assets/img/boxCloudQuestion.png';
import { shortFullName } from '../../utils';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0, 3),
  },
  containerQuestion: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  containerQuestionKamiContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  containerQuestionBox: {
    backgroundImage: `url(${questionBox})`,
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    justifyContent: 'center',
    minWidth: 470,
    height: 90,
    fontSize: '20px',
    fontWeight: 500,
    color: theme.palette.background.primary,
    fontFamily: 'Raleway',
    padding: theme.spacing(2, 0, 0, 0),
  },
  containerQuestionKami: {
    width: 150,
    transition: 'transform 0.5s linear',
    '&:hover': {
      transform: 'translateY(-30px)',
    },
  },
  containerQuestionText: {
    maxWidth: 470,
    margin: theme.spacing(2, 0),
  },
  containerQuestionDivider: {
    background: theme.palette.background.info,
    margin: theme.spacing(1, 0),
  },
  containerCloudAndQuestion: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  courseTitle: {
    fontSize: '20px',
    fontFamily: 'Raleway',
    fontWeight: 500,
    color: theme.palette.background.default,
    textAlign: 'center',
  },
  containerIntructions: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(0, 0, 0, 13),
  },
  containerIntructionsItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: theme.spacing(1, 0, 2, 0),
  },
  containerIntructionsItemIcon: {
    color: theme.palette.text.default,
    margin: theme.spacing(0, 2, 0, 0),
  },
  containerIntructionsItemText: {
    color: theme.palette.text.default,
    fontSize: 16,
    fontFamily: 'Raleway',
  },
  containerIntructionsItemSpan: {
    color: theme.palette.background.info,
    background: 'rgba(252, 208, 80, 0.15)',
    padding: theme.spacing(1),
    margin: theme.spacing(0, 0.5),
    borderRadius: 5,
  },
  containerIntructionsButton: {
    fontFamily: 'Raleway',
    margin: theme.spacing(3, 0, 0, 0),
  },
}));

function Question({
  question, instructions, start, dataQuestions,
}) {
  const classes = useStyles();
  const shortName = shortFullName();
  return (
    <Box>
      <Box className={classes.containerQuestion}>
        <Box className={classes.containerQuestionKamiContent}>
          <img src={bot1} alt="kamiQuizz" className={classes.containerQuestionKami} />
          <Box className={classes.containerCloudAndQuestion}>
            <Box className={classes.containerQuestionBox}>
              {`${shortName}, vamos a validar lo aprendido`}
            </Box>
            <Box className={classes.containerQuestionText}>
              <Typography className={classes.courseTitle}>{question}</Typography>
            </Box>
            <Divider className={classes.containerQuestionDivider} />
          </Box>
        </Box>
        {instructions
          ? (
            <Box className={classes.containerIntructions}>
              <Box className={classes.containerIntructionsItem}>
                <DescriptionOutlinedIcon className={classes.containerIntructionsItemIcon} />
                <Typography className={classes.containerIntructionsItemText}>
                  Esta prueba es de tipo
                  <span className={classes.containerIntructionsItemSpan}> opción única.</span>
                </Typography>
              </Box>
              <Box className={classes.containerIntructionsItem}>
                <ListIcon className={classes.containerIntructionsItemIcon} />
                <Typography className={classes.containerIntructionsItemText}>
                  Esta prueba tiene
                  <span className={classes.containerIntructionsItemSpan}>{`${dataQuestions} preguntas.`}</span>
                </Typography>
              </Box>
              <Box className={classes.containerIntructionsItem}>
                <CheckCircleOutlineRoundedIcon className={classes.containerIntructionsItemIcon} />
                <Typography className={classes.containerIntructionsItemText}>
                  Necesitas
                  <span
                    className={classes.containerIntructionsItemSpan}
                  >
                    {`${Math.trunc(dataQuestions / 2) + 1} respuestas correctas`}

                  </span>
                  <span>para aprobarlo.</span>
                </Typography>
              </Box>
              <Box>
                <Button variant="contained" color="secondary" className={classes.containerIntructionsButton} onClick={() => start()}>Comenzar</Button>
              </Box>
            </Box>
          ) : null}
      </Box>
    </Box>
  );
}

export default Question;

Question.propTypes = {
  question: PropTypes.string.isRequired,
  instructions: PropTypes.bool,
  start: PropTypes.func.isRequired,
  dataQuestions: PropTypes.number.isRequired,
};

Question.defaultProps = {
  instructions: false,
};
